import { DataTable } from "@/components/shared/data-table";
import type { CopyOperationMovementMapping } from "@/hooks/use-copy-operations";
import type { ContractMovement } from "@/lib/coach-manager/types";

interface CopyOperationMovementMappingsProps {
  movements: ContractMovement[];
  mappings: CopyOperationMovementMapping[];
}

function movementSummary(movement: ContractMovement): string {
  return (
    movement.MovementDescription ||
    [movement.Pickup, movement.Destination].filter(Boolean).join(" → ") ||
    `Movement ${movement.ContractMovementID}`
  );
}

/**
 * Source→target Movement ID mapping for a completed copy — one row per
 * source movement, matched to its `copy_operation_entity` row by
 * `String(movement.ContractMovementID) === mapping.sourceEntityId` (stable
 * regardless of DB row order).
 */
export function CopyOperationMovementMappings({
  movements,
  mappings,
}: CopyOperationMovementMappingsProps) {
  return (
    <div className="space-y-2">
      <h4 className="font-display text-sm font-semibold">Movements Copied</h4>
      <DataTable
        headers={[
          { label: "Movement" },
          { label: "Source Movement ID" },
          { label: "Target Movement ID" },
        ]}
        empty={<span className="text-sm text-muted-foreground">No movements were copied.</span>}
      >
        {movements.map((movement) => {
          const mapping = mappings.find(
            (m) => m.sourceEntityId === String(movement.ContractMovementID),
          );
          return (
            <tr key={movement.ContractMovementID} className="border-b last:border-b-0">
              <td className="px-4 py-2">{movementSummary(movement)}</td>
              <td className="px-4 py-2 text-muted-foreground">{movement.ContractMovementID}</td>
              <td className="px-4 py-2">{mapping?.targetEntityId ?? "—"}</td>
            </tr>
          );
        })}
      </DataTable>
    </div>
  );
}
